/* Surface Gaming skin customizer — VIEW half.
   Runs after sg-cust-model.js and renders window.SG_MODEL into the markup from
   sections/sg-skin-customizer.liquid. All shopper state lives here.
   Full notes: project doc claude/customizer-migration-progress.md

   A CUSTOMIZE page opens bare, so add-to-cart stays disabled until one part has
   a colour. ?edit=<cart line key> restores that line and REPLACES it on submit.
   Zoom is 3 steps; scales live in the CSS. The two disclosures start open every
   load so a returning shopper never assumes there is nothing to configure.
*/
(function(){
  "use strict";
  var root = document.getElementById("sg-cust");
  var M = window.SG_MODEL;
  if(!root) return;
  if(!M){ root.style.display = "none"; return; }

  var PARTS = M.PARTS, SUBS = M.SUBS, MATS = M.MATS, TOKENS = M.TOKENS;
  var byCode = M.byCode, BLANK = M.BLANK;
  function $(id){ return document.getElementById(id); }

  var state = { sub: SUBS.length ? SUBS[0] : "", part: PARTS[0].key, angle: "",
                picks: M.openingPicks(), addons: {} };
  TOKENS.forEach(function(t){ state.addons[t] = false; });
  var EDIT_KEY = M.editKey();

  /* WHAT THE SHOPPER BUILT DECIDES THE NAME — NOT WHERE THEY STARTED.
     One rule, every page. The finished recipe is matched against this device's
     named designs (the Featured / SG Theme / Full metal products, listed on the
     device record and each still owning its own recipe). An exact match on
     every part gives that design's name; anything else is "Your design".
     So a shopper who assembles Full metal by hand on the CUSTOMIZE page gets
     "Full metal", and one who nudges a single part off Featured gets
     "Your design" — and gets "Featured" back the moment they undo it, by any
     route, including restoring a cart line through Edit. There is no memory of
     the starting point to go stale, which is what the old flag got wrong.

     Add-ons and the sub-model are deliberately NOT compared: a spare skin set
     does not make the Featured colourway a different design, and nor does
     owning a G900 rather than a G903.

     This lives in the view, not the model: it is the label the shopper reads
     and the label written onto the line, and it needs the live picks. */
  var DESIGNS = (M.DEV && M.DEV.designs ? M.DEV.designs : [])
    .filter(function(d){ return d && d.name && d.picks; });

  /* A preset page must always be able to name itself, even if someone forgets
     to list it on the device record. */
  (function(){
    if(!M.PRESET || !M.PRESET_NAME) return;
    for(var i = 0; i < DESIGNS.length; i++){
      if(DESIGNS[i].name === M.PRESET_NAME) return;
    }
    DESIGNS.push({ name: M.PRESET_NAME, picks: M.PRESET });
  })();

  /* A recipe must account for every part. One that is silent about a part can
     never match, which is right: it is not a complete design. */
  function matchDesign(){
    for(var i = 0; i < DESIGNS.length; i++){
      var picks = DESIGNS[i].picks, ok = true;
      for(var j = 0; j < PARTS.length; j++){
        var k = PARTS[j].key;
        if(state.picks[k] !== picks[k]){ ok = false; break; }
      }
      if(ok) return DESIGNS[i].name;
    }
    return "";
  }
  function designName(){ return matchDesign() || "Your design"; }

  function anySkinned(){
    return PARTS.some(function(p){
      return !(BLANK && state.picks[p.key] === BLANK);
    });
  }

  function selected(){ return TOKENS.filter(function(t){ return state.addons[t]; }); }
  function currentVariant(){ return M.variantForSet(selected()) || M.BASE || M.VARS[0]; }

  /* stage and zoom */
  var stage = root.querySelector(".sg-stage");
  var elLayers = $("sgLayers");
  var baseImg = stage.querySelector(".sg-stage__base");
  var caption = $("sgCaption");

  var inner = document.createElement("div");
  inner.className = "sg-stage__inner";
  stage.insertBefore(inner, baseImg);
  inner.appendChild(baseImg);
  inner.appendChild(elLayers);

  var hint = document.createElement("div");
  hint.className = "sg-zoomhint";
  stage.appendChild(hint);

  var anglesBox = document.createElement("div");
  anglesBox.className = "sg-angles";
  anglesBox.setAttribute("role", "group");
  anglesBox.setAttribute("aria-label", "Camera angle");
  stage.parentNode.insertBefore(anglesBox, caption);

  stage.setAttribute("tabindex", "0");
  stage.setAttribute("role", "button");

  var HINTS = ["Tap to zoom", "Tap to zoom closer", "Tap to reset"];
  var LABELS = ["Zoom in on the mouse", "Zoom in further on the texture", "Reset the zoom"];

  var zoomLevel = 0, hiRes = false;
  function hi(u){ return String(u).replace(/([?&])width=\d+/, "$1width=2400"); }
  function res(u){ return hiRes ? hi(u) : u; }
  function upgrade(){
    if(hiRes) return;
    hiRes = true;
    Array.prototype.forEach.call(inner.querySelectorAll("img"), function(im){
      var h = hi(im.src);
      if(h === im.src) return;
      var pre = new Image();
      pre.onload = function(){ im.src = h; };
      pre.src = h;
    });
  }
  function originAt(cx, cy){
    var r = stage.getBoundingClientRect();
    if(!r.width || !r.height) return;
    var px = Math.max(0, Math.min(100, ((cx - r.left) / r.width) * 100));
    var py = Math.max(0, Math.min(100, ((cy - r.top) / r.height) * 100));
    inner.style.transformOrigin = px + "% " + py + "%";
  }
  function setZoom(n, cx, cy){
    zoomLevel = n;
    stage.classList.toggle("is-zoom1", n === 1);
    stage.classList.toggle("is-zoom2", n === 2);
    stage.setAttribute("aria-pressed", n > 0 ? "true" : "false");
    hint.textContent = HINTS[n];
    stage.setAttribute("aria-label", LABELS[n]);
    if(n === 0 || n === 1) inner.style.transformOrigin = "50% 50%";
    if(n === 2 && cx !== undefined) originAt(cx, cy);
    if(n > 0) upgrade();
  }

  stage.addEventListener("click", function(e){ setZoom((zoomLevel + 1) % 3, e.clientX, e.clientY); });
  stage.addEventListener("mousemove", function(e){ if(zoomLevel === 2) originAt(e.clientX, e.clientY); });
  stage.addEventListener("mouseleave", function(){ if(zoomLevel !== 0) setZoom(0); });
  stage.addEventListener("touchmove", function(e){
    if(zoomLevel !== 2 || !e.touches.length) return;
    e.preventDefault();
    originAt(e.touches[0].clientX, e.touches[0].clientY);
  }, { passive: false });
  stage.addEventListener("keydown", function(e){
    if(e.key === "Enter" || e.key === " "){ e.preventDefault(); setZoom((zoomLevel + 1) % 3); }
    if(e.key === "Escape" && zoomLevel !== 0) setZoom(0);
  });

  /* collapsible blocks */
  var CHEV =
    '<svg class="sg-block__chev" viewBox="0 0 20 20" aria-hidden="true" focusable="false">' +
    '<path d="M5 7.5 L10 12.5 L15 7.5" fill="none" stroke="currentColor" stroke-width="2.2" ' +
    'stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function makeCollapsible(block, bodyId, nodes, alsoHide){
    if(!block) return;
    var head = block.querySelector(".sg-block__head");
    var label = head && head.querySelector(".sg-block__label");
    if(!head || !label) return;

    var body = document.createElement("div");
    body.className = "sg-block__body";
    body.id = bodyId;
    block.appendChild(body);
    nodes.forEach(function(n){ if(n) body.appendChild(n); });

    var toggle = document.createElement("button");
    toggle.type = "button";
    toggle.className = "sg-block__toggle";
    toggle.setAttribute("aria-controls", bodyId);
    toggle.innerHTML = CHEV;
    head.insertBefore(toggle, label);
    toggle.appendChild(label);

    function set(open){
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
      body.hidden = !open;
      (alsoHide || []).forEach(function(el){ if(el) el.hidden = !open; });
    }
    toggle.addEventListener("click", function(){
      set(toggle.getAttribute("aria-expanded") !== "true");
    });
    set(true);
  }

  var elTabs = $("sgTabs"), elSwatches = $("sgSwatches"), applyAll = $("sgApplyAll");
  var partsBlock = elTabs.parentNode;

  makeCollapsible($("sgSubBlock"), "sgSubsBody", [$("sgSubs")]);
  makeCollapsible(partsBlock, "sgPartsBody", [elTabs, elSwatches], [applyAll]);

  var sgForm = $("sgForm");
  var editNote = document.createElement("p");
  editNote.className = "sg-editnote";
  editNote.hidden = true;
  editNote.textContent = "Editing an item in your cart — updating replaces it.";
  sgForm.insertBefore(editNote, $("sgSummary"));

  /* rendering */
  /* Nothing skinned yet is not a design, so the line stays out of the way
     until the shopper has picked something. */
  function renderSub(){
    var el = $("sgSub");
    if(!el) return;
    if(!anySkinned()){ el.hidden = true; el.textContent = ""; return; }
    el.hidden = false;
    el.textContent = designName();
  }

  function paintStage(){
    var b = M.baseFor(state.angle);
    if(b && baseImg.src !== res(b)) baseImg.src = res(b);

    var frag = document.createDocumentFragment();
    var missing = [], skinned = 0;
    PARTS.forEach(function(p){
      var code = state.picks[p.key];
      if(BLANK && code === BLANK) return;
      skinned++;
      var urls = M.layersFor(state.angle, p, code);
      /* Warn only when the part draws NOTHING: a multi-token part can have
         uneven coverage (G502 X Top = Body + Body_Back, 3 materials lack the
         back piece) and a warning there alarms shoppers over nothing. */
      if(!urls.length) missing.push(p.label);
      urls.forEach(function(u){
        var im = document.createElement("img");
        im.src = res(u);
        im.alt = ""; im.decoding = "async";
        frag.appendChild(im);
      });
    });
    elLayers.innerHTML = "";
    elLayers.appendChild(frag);

    var cap = skinned
      ? skinned + " of " + PARTS.length + " parts skinned"
      : "Nothing skinned yet — pick a colour for any part";
    if(M.ANGLES.length > 1) cap = M.angleLabel(state.angle) + " · " + cap;
    if(missing.length) cap += " · no photo yet for " + missing.join(", ") + " at this angle";
    caption.textContent = cap;
  }

  function renderAngles(){
    if(M.ANGLES.length < 2){ anglesBox.style.display = "none"; return; }
    anglesBox.style.display = "";
    anglesBox.innerHTML = "";
    M.ANGLES.forEach(function(a){
      var thumb = M.baseFor(a);
      if(!thumb) return;
      var b = document.createElement("button");
      b.type = "button"; b.className = "sg-angle";
      b.title = M.angleLabel(a);
      b.setAttribute("aria-label", M.angleLabel(a));
      b.setAttribute("aria-pressed", state.angle === a ? "true" : "false");
      var im = document.createElement("img");
      im.src = thumb.replace(/([?&])width=\d+/, "$1width=200");
      im.alt = ""; im.loading = "lazy"; im.decoding = "async";
      b.appendChild(im);
      b.addEventListener("click", function(){
        state.angle = a;
        setZoom(0);
        renderAngles();
        paintStage();
      });
      anglesBox.appendChild(b);
    });
  }

  function renderSubs(){
    var box = $("sgSubs");
    if(!SUBS.length){ $("sgSubBlock").style.display = "none"; return; }
    box.innerHTML = "";
    SUBS.forEach(function(s){
      var b = document.createElement("button");
      b.type = "button"; b.className = "sg-chip"; b.textContent = s;
      b.setAttribute("aria-pressed", state.sub === s ? "true" : "false");
      b.addEventListener("click", function(){ state.sub = s; renderSubs(); sync(); });
      box.appendChild(b);
    });
  }

  function renderTabs(){
    elTabs.innerHTML = "";
    PARTS.forEach(function(p){
      var b = document.createElement("button");
      b.type = "button"; b.className = "sg-tab";
      b.setAttribute("aria-selected", state.part === p.key ? "true" : "false");
      var m = byCode[state.picks[p.key]] || { name: "-" };
      var em = document.createElement("em");
      em.textContent = p.label;
      var sm = document.createElement("small");
      sm.textContent = m.name;
      b.appendChild(em); b.appendChild(sm);
      b.addEventListener("click", function(){ state.part = p.key; renderTabs(); renderSwatches(); });
      elTabs.appendChild(b);
    });
  }

  function renderSwatches(){
    elSwatches.innerHTML = "";
    var cur = state.picks[state.part];
    MATS.forEach(function(m){
      var b = document.createElement("button");
      b.type = "button"; b.className = "sg-sw"; b.title = m.name;
      b.setAttribute("aria-label", m.name);
      b.setAttribute("aria-pressed", cur === m.code ? "true" : "false");
      var s = document.createElement("span");
      var url = M.swatchFor(m);
      if(url) s.style.backgroundImage = "url('" + url + "')";
      b.appendChild(s);
      b.addEventListener("click", function(){
        state.picks[state.part] = m.code;
        renderTabs(); renderSwatches(); sync();
      });
      elSwatches.appendChild(b);
    });
    /* No selected-material readout: the part tab already names it. */
  }

  function renderAddons(){
    var box = $("sgAddons");
    box.innerHTML = "";
    if(!TOKENS.length){ $("sgAddonBlock").style.display = "none"; return; }
    var base = selected();
    TOKENS.forEach(function(t){
      var withT = base.indexOf(t) > -1 ? base : base.concat([t]);
      var withoutT = base.filter(function(x){ return x !== t; });
      var vOn = M.variantForSet(withT), vOff = M.variantForSet(withoutT);
      var lab = document.createElement("label");
      lab.className = "sg-addon";
      var cb = document.createElement("input");
      cb.type = "checkbox";
      cb.checked = !!state.addons[t];
      var bEl = document.createElement("b");
      bEl.textContent = t.replace(/^&\s*/, "");
      var iEl = document.createElement("i");
      if(vOn && vOff){
        var d = M.amountOf(vOn) - M.amountOf(vOff);
        iEl.textContent = (d >= 0 ? "+" : "-") + M.symbol() + Math.abs(d).toFixed(2);
      } else {
        iEl.textContent = "unavailable together";
        cb.disabled = true;
        lab.className += " is-off";
      }
      lab.appendChild(cb); lab.appendChild(bEl); lab.appendChild(iEl);
      cb.addEventListener("change", function(){
        state.addons[t] = cb.checked;
        renderAddons(); sync();
      });
      box.appendChild(lab);
    });
  }

  function sync(){
    paintStage();
    /* Derived, so no colour change can ever forget to update the name. */
    renderSub();
    var v = currentVariant();
    $("sgVariantId").value = v ? v.id : "";
    var txt = v && v.priceText ? v.priceText : M.symbol() + M.amountOf(v).toFixed(2);
    $("sgPrice").innerHTML = txt;
    $("sgAddPrice").innerHTML = txt;

    /* All-bare is not a product: say what is missing, never sell an empty wrap. */
    var skinned = anySkinned();
    var ok = !!(v && v.available) && skinned;
    $("sgAdd").disabled = !ok;
    $("sgAddText").textContent = !skinned ? "Pick a colour to start"
      : (!(v && v.available) ? "Unavailable" : (EDIT_KEY ? "Update cart" : "Add to cart"));
    $("sgAddPrice").hidden = !skinned;

    var props = $("sgProps");
    props.innerHTML = "";
    function prop(k, val){
      var i = document.createElement("input");
      i.type = "hidden"; i.name = "properties[" + k + "]"; i.value = val;
      props.appendChild(i);
    }
    if(state.sub) prop("SubModel", state.sub);
    /* Carry the design name onto the line so the cart and the order say what
       the shopper saw — on every configurable page, however they got there.
       The cart swaps the trailing segment of the product title for this, so a
       hand-built Full metal reads "Full metal" and not "CUSTOMIZE". */
    if(skinned) prop("Design", designName());
    PARTS.forEach(function(p){
      var m = byCode[state.picks[p.key]];
      prop(p.key, ((BLANK && state.picks[p.key] === BLANK) || !m) ? "-" : m.name);
    });

    var dl = document.createElement("dl");
    function row(k, val){
      var dt = document.createElement("dt"); dt.textContent = k;
      var dd = document.createElement("dd"); dd.textContent = val;
      dl.appendChild(dt); dl.appendChild(dd);
    }
    if(state.sub) row("Model", state.sub);
    PARTS.forEach(function(p){
      var m = byCode[state.picks[p.key]];
      row(p.label, ((BLANK && state.picks[p.key] === BLANK) || !m) ? "Left bare" : m.name);
    });
    var chosen = selected();
    if(chosen.length) row("Add-ons", chosen.map(function(t){ return t.replace(/^&\s*/, ""); }).join(", "));
    var sum = $("sgSummary");
    sum.innerHTML = "";
    sum.appendChild(dl);
  }

  if(applyAll) applyAll.addEventListener("click", function(){
    var c = state.picks[state.part];
    PARTS.forEach(function(p){ state.picks[p.key] = c; });
    renderTabs(); renderSwatches(); sync();
  });

  function renderAll(){
    renderSub(); renderSubs(); renderTabs(); renderSwatches(); renderAddons(); sync();
  }

  /* Seam for sg-cust-edit.js, which restores a cart line into this state and
     makes the form replace that line instead of adding a second one. Kept in a
     separate file so this one has room to grow. */
  window.SG_VIEW = {
    state: state, form: sgForm, note: editNote, renderAll: renderAll,
    touch: function(){ /* kept for sg-cust-edit.js; the name is derived now */ },
    cancelEdit: function(){ EDIT_KEY = ""; sync(); }
  };

  setZoom(0);
  renderAngles();
  renderAll();
})();
